import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
}));



// WEBPACK FOOTER //
// ./src/components/SignUp/components/LoanOfficerRegistration/useStyles.js